import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, CONTENT_POINT_SCHEMA, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** Two to four short store promises on pastel tiles with a line icon. */
export const schema: ComponentSchema = {
  type: 'promises',
  label: 'Promises strip',
  description: 'Short promises parents look for (cash on delivery, delivery all over Bangladesh, safe materials, easy returns) on pastel tiles.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Pastel tiles' }],
  commonFields: [
    ...headingFields(),
    {
      key: 'items',
      label: 'Promises',
      type: 'array',
      itemSchema: CONTENT_POINT_SCHEMA,
      default: [
        { icon: 'cash', title: { en: 'Cash on delivery', bn: 'ক্যাশ অন ডেলিভারি' }, body: { en: 'Pay when the parcel reaches your door.', bn: 'পার্সেল হাতে পেয়ে টাকা দিন।' } },
        { icon: 'truck', title: { en: 'All over Bangladesh', bn: 'সারা বাংলাদেশে' }, body: { en: 'Dhaka in 1–2 days, everywhere else in 3–5.', bn: 'ঢাকায় ১–২ দিন, অন্যত্র ৩–৫ দিন।' } },
        { icon: 'shield', title: { en: 'Safe for little hands', bn: 'ছোট হাতের জন্য নিরাপদ' }, body: { en: 'Child-safe materials, checked before they ship.', bn: 'শিশুর জন্য নিরাপদ উপকরণ, পাঠানোর আগে যাচাই করা।' } },
        { icon: 'refresh', title: { en: 'Easy returns', bn: 'সহজ রিটার্ন' }, body: { en: 'Not the right fit? Return it within 7 days.', bn: 'পছন্দ না হলে ৭ দিনের মধ্যে ফেরত দিন।' } },
      ],
    },
    ...SECTION_STYLE_FIELDS,
  ],
}
